import { t } from "i18next";
import React from "react";
import { Trans } from "react-i18next";
import { useParams } from "react-router-dom";
import phEmoji from "../../../assets/images/blurred2/imoji/thinking.png";
import phBuilding from "../../../assets/images/blurred2/income/1.png";
import phHouse from "../../../assets/images/blurred2/income/2.png";
import HorizontalButton from "../../../components/HorizontalButton";
import ImageButton from "../../../components/ImageButton";
import MobileViewLayout from "../../../layouts/MobileViewLayout";
import { addS3Url } from "../../../utils/modules";

const imagesToPreload = [
  "/income/PigiBank.jpg",
  "/levels/Low.png",
  "/levels/Middle.png",
  "/levels/High.png",
];

const data = [
  {
    buttonText: t("income_source.job"),
    image: addS3Url("/income/1.png"),
    placeHolderImage: phBuilding,
  },
  {
    buttonText: t("income_source.freelance"),
    image: addS3Url("/income/2.png"),
    placeHolderImage: phHouse,
  },
];

const IncomeSrc = () => {
  const params = useParams();

  return (
    <MobileViewLayout>
      <div className="d-flex align-items-center justify-content-center px-3">
        <div className="w-100">
          <h2 className="text-black fw-bold text-center fs30 incomesrc-selection-heading m-0">
            <Trans i18nKey={"income_source.question"} />
          </h2>
          <div className="d-flex flex-column justify-content-around align-items-center">
            <div className="d-flex justify-content-around align-items-center w-100">
              {data.map((item, index) => (
                <ImageButton
                  key={index}
                  highlightButton={"button-highlight"}
                  backgroundStyle={{
                    backgroundColor: "#F2F2F2",
                    paddingBottom: "5px",
                    height: "165px",
                  }}
                  imageStyle={{
                    width: "40% !important",
                    height: "70px",
                    marginTop: "20px",
                  }}
                  navigateTo={{
                    pathname: `/${params.gender}/level`,
                  }}
                  buttonClasses={
                    "pb-2 fw-bold incomesrc-button secondaryTextSize fs18"
                  }
                  imagesToPreload={imagesToPreload}
                  {...item}
                />
              ))}
            </div>
            <div className="w-100 px-2 ">
              <HorizontalButton
                navigateTo={{
                  pathname: `/${params.gender}/level`,
                }}
                className={"secondaryTextSize fs18"}
                label={t("income_source.other")}
                imagesToPreload={imagesToPreload}
                image={addS3Url("/imoji/thinking.png")}
                placeHolderImage={phEmoji}
              />
            </div>
          </div>
        </div>
      </div>
    </MobileViewLayout>
  );
};

export default IncomeSrc;
